<div class="container-fluid contentHeight">
    <div class="title containerTitle">
        <span class="text-center" [translate]="'history.history'">  </span>
    </div>
    <div class="tab">
        <button (click)="toggleCommand()"><span [translate]="'history.order'"></span></button>
        <button (click)="toggleQuote()"><span [translate]="'history.quote'"></span></button>
    </div>
    <div *ngIf="orderHistory.length > 0 && showCommand">
        <h1 class="text-center" [translate]="'history.orderhistory'"> </h1>
        <div class="text-center virTitle ">
            <div (click)="displayRibModal()">
                <i aria-hidden="true" class="fal fa-money-check-alt mr-2"></i> <span [translate]="'shoppingcart.infoBancaire'">  </span>
            </div>
            <!--<div (click)="chequePayment()">
                <i  aria-hidden="true" class="fal fa-money-check-edit mr-2"></i><span  [translate]="'shoppingcart.cheque'">  </span>
            </div>-->
        </div>
        <div class="row">
            <div class=" col-11 mx-auto history">
                <table class=" table table-bordered bg-light">
                    <caption></caption>
                    <thead>
                        <tr>
                            <th scope="col" class="font-weight-bold" [translate]="'history.date'"></th>
                            <th scope="col" class="font-weight-bold" [translate]="'shoppingcart.historyLabelVir'"> </th>
                            <th scope="col" class="font-weight-bold" [translate]="'history.orderDetail'"> </th>
                            <th scope="col" class="font-weight-bold" [translate]="'common.balance'"> </th>
                            <th scope="col" class="font-weight-bold text-center" [translate]="'activlist.activdateend'"> </th>
                            <th scope="col" class="font-weight-bold" [translate]="'activlist.activcode'"> </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let info of orderHistory" class="histTr">
                            <td class="font-weight-bold"> {{info.transDate | date:'dd/MM/yyyy HH:mm'}}</td>
                            <td *ngIf="info.haveLicence == true" class="font-weight-bold"> IxellColorConnect/{{info.unisiteCode}}/{{info.code}}/{{info.activationId}}</td>
                            <td *ngIf="info.haveLicence == false" class="font-weight-bold"> {{info.orderNumber}}</td>
                            <td class="orderTd">
                                <table class="orderTableWidth">
                                    <caption></caption>
                                    <thead>
                                        <tr>
                                            <th scope="col" class="font-weight-bold" [translate]="'history.produit'"> </th>
                                            <th scope="col" class="font-weight-bold" [translate]="'shoppingcart.prix'"> </th>
                                            <th scope="col" class="font-weight-bold" [translate]="'shoppingcart.quantite'"> </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let detail of info.orderDetails">
                                            <td class="productWidth">{{detail.labelP}} </td>
                                            <td> {{detail.amountP}} </td>
                                            <td class="text-center"> {{detail.qty}} </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right"> <span class="font-weight-bold" [translate]="'shoppingcart.prixttc'"> </span> : {{info.amountTotal | number : '1.2-2'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td *ngIf="info.haveLicence == true" class="text-center"> {{info.code}} </td>
                            <td *ngIf="info.haveLicence == false"></td>
                            <td *ngIf="info.haveLicence == true"> {{info.licenceEnd | date:'dd/MM/yyyy'}} </td>
                            <td *ngIf="info.haveLicence == false"></td>
                            <td *ngIf="info.haveLicence == true"> {{info.activationCode}} </td>
                            <td *ngIf="info.haveLicence == false"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div *ngIf="quoteHistory.length > 0 && showQuote">
        <h1 class="text-center" [translate]="'history.quotehistory'"> </h1>
        <div class="row">
            <div class=" col-8 mx-auto history">
                <table class=" table table-bordered bg-light">
                    <caption></caption>
                    <thead>
                        <tr>
                            <th scope="col" class="font-weight-bold" [translate]="'history.date'"></th>
                            <th scope="col" class="font-weight-bold" [translate]="'shoppingcart.historyLabelVir'"> </th>
                            <th scope="col" class="font-weight-bold" [translate]="'history.orderDetail'"> </th>
                            <th scope="col" class="font-weight-bold" [translate]="'history.quoteValidate'"> </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let info of quoteHistory" class="histTr">
                            <td class="font-weight-bold"> {{info.transDate | date:'dd/MM/yyyy HH:mm'}}</td>
                            <td class="font-weight-bold"> {{info.orderNumber}}</td>
                            <td class="orderTd">
                                <table class="orderTableWidth">
                                    <caption></caption>
                                    <thead>
                                        <tr>
                                            <th scope="col" class="font-weight-bold" [translate]="'history.produit'"> </th>
                                            <th scope="col" class="font-weight-bold" [translate]="'shoppingcart.prix'"> </th>
                                            <th scope="col" class="font-weight-bold" [translate]="'shoppingcart.quantite'"> </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let detail of info.orderDetails">
                                            <td class="productWidth">{{detail.labelP}} </td>
                                            <td> {{detail.amountP}} </td>
                                            <td class="text-center"> {{detail.qty}} </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3" class="text-right"> <span class="font-weight-bold" [translate]="'shoppingcart.prixttc'"> </span> : {{info.amountTotal | number : '1.2-2'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td *ngIf="info.transStatus == 18" class="text-center">
                                <i aria-hidden="true" class="fas fa-check fa-1-2x green"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- Modal d'information -->
    <div *ngIf="bankInfoLacour" id="modalRIB" class="modal">
        <div class="modal-content">
            <span class="text-right mr-2 pointer close" (click)="closeRibModal();">  <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
            <div class="container">
                <div class="row">
                    <div class="col-8 mx-auto bg-light">
                        <!-- <h3 class="text-info text-center" [translate]="'shoppingcart.rib'">  </h3> -->
                        <span [translate]="'shoppingcart.idinternational'"> </span>
                        <div class="ribBox mb-2">
                            <div *ngIf="bankInfoLacour.iban" class="col-12"> <span class="font-weight-bold " [translate]="'shoppingcart.iban'">  </span> : {{bankInfoLacour.iban}}</div>
                            <div *ngIf="bankInfoLacour.bic" class="col-12"> <span class="font-weight-bold" [translate]="'shoppingcart.bic'">  </span> : {{bankInfoLacour.bic}} </div>
                        </div>
                        <span *ngIf="bankInfoLacour.owner" [translate]="'shoppingcart.titulaire'">  </span> <span class="font-weight-bold"> : {{bankInfoLacour.owner}} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--
<div id="ModalCheque" class="modal">
  <div class="modal-content">
    <div class="row">
      <div class="col-12">
        <span class="rightFlex close" (click)="closeChequePayment();">
          <i  aria-hidden="true" class="fad fa-times fa-3x " style=" cursor: pointer ; --fa-primary-color: #e0003c; --fa-secondary-color: #e8641b;"></i>
        </span>
        <h1 class="text-center" [translate]="'shoppingcart.infocheque'"></h1>
      </div>
    </div>
    <div>
    <div class="ribBox mb-2 col-8 mx-auto">
    <ul>
      <li>
        <div *ngIf="bankInfoLacour.address != null">
          <span class="font-weight-bold" [translate]="'shoppingcart.adresse'"></span> :
          <div *ngFor="let a of bankInfoLacour.address.split('|')">{{a}}</div>
        </div>
      </li>
      <li>
        <span class="font-weight-bold" [translate]="'shoppingcart.info'"></span> : {{cu}}/{{scale}}
      </li>
      <li>
        <span class="font-weight-bold" [translate]="'shoppingcart.ordre'"></span> : {{bankInfoLacour.order}}
      </li>
      <li>
        <span class="font-weight-bold" [translate]="'shoppingcart.montant'"></span> : {{orderAmountTTC}} €
      </li>
    </ul>
  </div>
    </div>
  </div>
</div>-->
